import { render, staticRenderFns } from "./HealthcareHeader.vue?vue&type=template&id=789fc7c0&"
import script from "./HealthcareHeader.vue?vue&type=script&lang=js&"
export * from "./HealthcareHeader.vue?vue&type=script&lang=js&"
import style0 from "./HealthcareHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports